import React from "react";

import Link from "../../Link";
import { currencyFormat } from "../../../utils";
import { FEES, MONTHLY_FEES, RATES } from "./constants";
import Text from "../../Text";
import { COLOR } from "../../theme";

export const Minimum = ({
 // onLearnMoreClick = () => { },
  currency,
  //learnMoreURL,
  au,
  nz,
}) => {
  const monthlyPrice = currencyFormat(MONTHLY_FEES[currency]);

  const AU = () => (
    <>
      <Text textStyle="body2" margin="0 0 3" color={COLOR.LATITUDE_BLUE_INDIGO}>
        <strong>
          Make the minimum payment on your credit card each month.
        </strong>
      </Text>

      <Text textStyle="body2" margin="0 0 3" color={COLOR.LATITUDE_BLUE_INDIGO}>
        <strong>Monthly credit card fee (currently ${monthlyPrice})</strong> will apply. Paying
        only the minimum monthly payments will not pay out the plan.
        After the interest free plan ends interest will be charged on any
        outstanding balance at the expired plan rate, currently {RATES.GEM_VISA_AU}%
        p.a. (subject to change).
      </Text>

      {/* {!window.location.pathname.includes('/payment/complete') && (
        <Link onClick={onLearnMoreClick} href={learnMoreURL} newTab smallFont>
          Learn more
        </Link>
      )} */}
    </>
  );

  const NZ = () => (
    <>
      <Text textStyle="body2" margin="0 0 3" color={COLOR.LATITUDE_BLUE_INDIGO}>
        <strong>
          Pay your credit card minimum payment each month.
        </strong>
      </Text>

      <Text textStyle="body2" margin="0 0 3" color={COLOR.LATITUDE_BLUE_INDIGO}>
        Paying only the minimum monthly payment will not pay out the purchase before the end of the plan. Lending criteria, T&C's and fees apply including a
        ${FEES.ESTABLISHMENT} establishment fee  &amp; ${FEES["GEM_VISA"]} annual fee ($
        {FEES["GEM_VISA_HALF_YEARLY"]} half yearly ). Interest (currently {RATES.GEM_VISA_NZ}% p.a.)applies after any interest free plan expires.
      </Text>

      {/* {!window.location.pathname.includes('/payment/complete') && (
        <Link onClick={onLearnMoreClick} href={learnMoreURL} newTab smallFont>
          Learn more
        </Link>
      )} */}
    </>
  );

  return (
    <>
      {au && <AU />}
      {nz && <NZ />}
    </>
  );
};